export default __webpack_public_path__ + "static/media/product-10 (2).4890e19f.jpg";